class ComponentVideo extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    this.defineElements({
      video: "video",
      button: "button",
      poster: "img"
    });

    if (this.data.lazy) {
      this.lazyLoadObserver();
    }

    this.togglePlaybackVisibility();
    this.addActionEvents();
  }

  play() {
    this.pauseAll();
    this.elements.video.play();
    this.setAttribute("playing", true);
  }

  pause() {
    if (this.elements.video) {
      this.elements.video.pause();
      this.removeAttribute("playing");
    }
  }

  pauseAll() {
    document.querySelectorAll("component-video").forEach((component) => {
      component.pause();
    });
  }

  lazyLoadObserver() {
    this.intersectionObserver((entry, observer) => {
      if (entry.isIntersecting) {
        this.lazyLoad();
        observer.unobserve(this);
      }
    }, { rootMargin: "0px 50%", threshold: 0 });
  }

  lazyLoad() {
    if (this.elements.video) {
      return;
    }

    const video = document.createElement("video");

    video.setAttribute("poster", this.elements.poster.src);
    video.setAttribute("preload", "metadata");
    video.setAttribute("playsinline", true);

    for (const attribute in this.data.attributes) {
      video[attribute] = this.data.attributes[attribute];
    }

    this.data.sources.forEach((source) => {
      const element = document.createElement("source");
      element.src = source.url;
      element.type = source.mime_type;
      video.appendChild(element);
    });

    this.elements.poster.insertAdjacentElement("afterend", video);

    video.load();

    video.addEventListener("loadeddata", () => {
      this.defineElements({
        video: "video"
      });
    }, { once: true });
  }

  togglePlaybackVisibility() {
    this.intersectionObserver((entry) => {
      const visible = entry.isIntersecting;

      if (!visible) {
        this.pause();
      }

      if (visible && this.data.attributes.autoplay) {
        this.play();
      }
    });
  }
}

customElements.define("component-video", ComponentVideo);
